import { observable, action, runInAction } from 'mobx'
import BaseStore from './baseStore'
import { playModeStatus } from '@/api/api'

const initPlayerSongData = {
  songname: '',
  singername: '',
  next_songname: '',
  next_singername: '',
  dration: 0,
  played: 0,
  url: '',
  played_ms: 0,
  img: '',
}

let timer: any = null

class SongStore extends BaseStore {
  @observable
  isPlaying = false

  @observable
  currentPlayerSongData: any = initPlayerSongData

  @observable
  currentChooseSongData: any = {}

  @observable
  chooseSongModalVisible = false

  @observable
  videoPlayerModalVisible = false

  @observable
  isChooseSongEdit = false

  @observable
  hideAddCollect = false

  @observable
  remoteControlVisible = false

  @observable
  advertDetailVisible = false

  @action
  updateAdvertDetailVisible(val: boolean = true) {
    this.advertDetailVisible = val
  }

  @action
  updateRemoteControlVisible(val: boolean = true) {
    this.remoteControlVisible = val
  }

  @action
  updateVideoPlayerModalVisible(val: boolean = true) {
    this.videoPlayerModalVisible = val
  }

  @action
  updateChooseSongModalVisible(val: boolean = true) {
    this.chooseSongModalVisible = val

    // if (!val) {
    //   this.currentChooseSongData = {}
    // }
  }

  @action
  setCurrentPlayerSongData(data: any) {
    this.currentPlayerSongData = data
  }

  async getPlayModeStatus() {
    const data: any = await playModeStatus()

    // if (data.played === data.dration) {
    //   clearInterval(timer)
    //   this.isPlaying = false
    //   this.currentPlayerSongData = initPlayerSongData
    //   return
    // }

    runInAction(() => {
      this.currentPlayerSongData = data
    })
  }

  @action
  startPlaySong({ polling = true } = {}) {
    this.getPlayModeStatus()
    this.isPlaying = true

    if (!polling) return

    if (timer) {
      this.clearPlayStatus()
    }

    timer = setInterval(this.getPlayModeStatus.bind(this), 3000)
  }

  @action
  clearPlayStatus() {
    clearInterval(timer)
  }
}

export default SongStore
